<section id="Services">
  <div class="row">
    <div class="title-section">
      <h3></h3>
    </div>
    <div class="body-section">
      <div class="column medium-6">
        <strong>
          <a routerLink="/training/start-point">
            <i>
              <img
                with="32px"
                class="normal style-svg"
                src="../../../assets/images/start.svg"
              />
              <img
                class="hover style-svg"
                src="../../../assets/images/start.svg"
                style="fill: #cd2027"
              />
            </i>
            از کجا شروع کنم
          </a>
        </strong>
        <p>
          اگر اولین بار است که می خواهید در بورس سرمایه گذاری کنید، از اینجا
          شروع کنید.
        </p>
      </div>
      <!-- <div class="column medium-6">
                <strong>
                    <a  routerLink="/customers/services/how-to-register">
                        <i>
                            <img with="32px" class="normal style-svg" src="../../../assets/images/account.svg">
                            <img class="hover style-svg" src="../../../assets/images/account.svg" style="fill:#cd2027">
                        </i>
                        افتتاح حساب </a>
                </strong>
                <p>با تکمیل نمودن این فرم ثبت نام در سجام، دریافت کد بورسی و افتتاح حساب خود را انجام دهید.</p>
            </div> -->
      <!-- <div class="column medium-4"> -->
      <!-- <strong>
                    <a href="https://booking.aban.net">
                        <i>
                            <img with="32px" class="normal style-svg" src="../../../assets/images/calendar.svg">
                            <img class="hover style-svg" src="../../../assets/images/calendar.svg" style="fill:#cd2027">
                        </i>
                        سامانه نوبت‌دهی </a>
                </strong>
                <p>پیش از حضور در دفاتر آبان، با استفاده از این سامانه نسبت به تعیین وقت اقدام کنید.</p> -->
      <!-- </div> -->
      <!-- <div class="column medium-6">
        <strong>
          <a [routerLink]="['/aban/support']">
            <i>
              <img
                with="32px"
                class="normal style-svg"
                src="../../../assets/images/help.png"
              />
              <img
                class="hover style-svg"
                src="../../../assets/images/help.png"
                style="fill: #cd2027"
              />
            </i>
            سامانه پشتیبانی
          </a>
        </strong>
        <p>
          جهت دریافت خدمات پشتیبانی، درخواست‌های خود را در این سامانه ثبت
          نمایید.
        </p>
      </div> -->
      <div class="column medium-6">
        <strong>
          <a routerLink="/aban/cooperation-request">
            <i>
              <img
                with="32px"
                class="normal style-svg"
                src="../../../assets/images/cooperation.svg"
              />
              <img
                class="hover style-svg"
                src="../../../assets/images/cooperation.svg"
                style="fill: #cd2027"
              />
            </i>
            پیشنهاد همکاری
          </a>
        </strong>
        <p>ما منتظر شنیدن ایده های شما برای شروع همکاری های جدید هستیم.</p>
      </div>
      <div class="column medium-6">
        <strong>
          <a routerLink="/aban/job-opportunities">
            <i>
              <img
                with="32px"
                class="normal style-svg"
                src="../../../assets/images/job.svg"
              />
              <img
                class="hover style-svg"
                src="../../../assets/images/job.svg"
                style="fill: #cd2027"
              />
            </i>
            فرصت های شغلی
          </a>
        </strong>
        <p>
          جهت ارائه خدمات حرفه‌ای و برتر، شما را به همکاری با آبــان دعوت می
          کنیم.
        </p>
      </div>
    </div>
  </div>
</section>
